import { LinearProgress } from "@mui/material";
import React from "react";

export default function MuiLinearProgress({ sx }: { sx?: any }) {
  return (
    <LinearProgress
      sx={{ position: "absolute", width: "100%", top: 0, left: 0, ...sx }}
    />
  );
}
